<template>
	<div class="powerlist">
    <ul class="flex-js-ac">
      <li class="flex-1" :class="{'navColor': navIndex==index}" v-for="(item, index) of nav" @click="navClick(index)">{{item}}</li>
    </ul>
    <div class="h"></div>
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              @on-refresh="onRefresh"
              @on-infinite="onInfinite"
              class="my_scroller"
              ref="my_scroller"

    >
      <div class="flex-ac f14 rank" v-if="rank && navIndex == 1">
        <img src="/static/images/newproducttrial/rank.png">
        <span>当前实时排名：第{{rank}}名</span>
      </div>
      <div class="list" v-if="navIndex == 0 && list.length">
        <div class="ranking flex-js-ac" v-if="list.length >= 3">
          <div class="No No2">
            <img src="/static/images/newproducttrial/new_product-icon-two@2x.png">
            <div class="content">
              <img :src="list[1].headimg" @error="function(event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}">
              <p class="f14 over-ell-1">{{list[1].name}}</p>
              <b class="f15">{{list[1].score}}</b>
              <span class="f10">助力值</span>
            </div>
          </div>
          <div class="No No1">
            <img src="/static/images/newproducttrial/new_product-icon-one@2x.png">
            <div class="content">
              <img :src="list[0].headimg" @error="function(event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}">
              <p class="f14 over-ell-1">{{list[0].name}}</p>
              <b class="f15">{{list[0].score}}</b>
              <span class="f10">助力值</span>
            </div>
          </div>
          <div class="No No3">
            <img src="/static/images/newproducttrial/new_product-icon-three@2x.png">
            <div class="content">
              <img :src="list[2].headimg" @error="function(event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}">
              <p class="f14 over-ell-1">{{list[2].name}}</p>
              <b class="f15">{{list[2].score}}</b>
              <span class="f10">助力值</span>
            </div>
          </div>
        </div>
        <ul class="listitem">
          <li class="flex-js-ac" v-for="(item, index) of list" v-if="list.length >= 3 ? index >= 3 : true">
            <div class="nickname flex-ac">
              <span class="f14">{{index+1}}</span>
              <img :src="item.headimg" @error="function(event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}">
              <p class="f14">{{item.name}}</p>
            </div>
            <b class="f14">{{item.score}}</b>
          </li>
        </ul>
      </div>
      <div class="list list_gray" v-else-if="navIndex == 1 && list.length">
        <ul class="listitem">
          <li class="flex-js-ac" v-for="(item, index) of list">
            <div class="nickname flex-ac">
              <img :src="item.headimg" @error="function(event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}">
              <p class="f14 over-ell-1">{{item.name}}</p>
            </div>
            <span class="f14 color-FC0324">{{item.score}}</span>
            <b class="f14">&nbsp;&nbsp;{{item.time}}</b>
          </li>
        </ul>
      </div>
    </Scroller>
    <div v-if="empty" class="integral">
      <div class="intCenter">
        <img src="../../assets/images/emptyorder.png">
        <p style="white-space: nowrap">啊哦，暂无数据哦~</p>
      </div>
    </div>
  </div>
</template>

<script>
import Scroller from '../common/Scroller'
export default {
  name: 'powerlist',
  components: {
    Scroller
  },
  data () {
    return {
      navIndex: 0,
      nav: ['助力排行榜', '我的助力'],
      list: [],
      rank: 0,
      empty: false,
      nowPage: 0,
      refresh: false,
      loading: false,
      finished: false,
      pagesize: 20
    }
  },
  methods: {
    getData () {
      var url = this.$ajax.getShareTop_URL
      if (this.navIndex == 1) {
        url = this.$ajax.getShare_URL
      }
      url = url + '?pageNo=' + this.nowPage + '&pageSize=' + this.pagesize + '&actid=' + this.$route.query.actid
      this.$customRequestAjax(url).then(res => {
        if (res.data.code == 200) {
          if (this.navIndex == 1) {
            this.rank = res.data.ranknum ? res.data.ranknum : 0
          } else {
            this.rank = 0
          }
          if (this.nowPage == 1) {
            this.list = res.data.list
            this.empty = res.data.list.length <= 0
            this.refresh = false
          } else {
            this.list = this.list .concat(res.data.list)
          }
          this.loading = false
          this.finished = res.data.list.length < this.pagesize
        }
      })
    },
    navClick (id) {
      this.list = []
      this.navIndex = id
      this.nowPage = 1
      this.getData()
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      that.nowPage++
      that.getData()
    }
  }
}
</script>

<style scoped lang="scss">
  .powerlist {
    >ul {
      font-size: 0;
      flex: 1;
      text-align: center;
      background: #ffffff;
      height: 0.46rem;
      padding: 0 0.6rem;
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 1;
      border-bottom: 0.01rem solid #F5F5F5;
      li {
        display: inline-block;
        font-size: 0.17rem;
        color: #191818;
        &.navColor {
          color: #292929;
          font-weight:bold;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            display: block;
            width: 0.26rem;
            height: 0.03rem;
            background: linear-gradient(180deg, #FC0324 0%, #F63A66 100%);
          }
        }
      }
    }
    .h {
      height: 0.46rem;
    }
    .rank {
      margin: 0.1rem 0.11rem 0;
      background: #ffffff;
      border-radius: 0.08rem;
      padding: 0.1rem 0.11rem;
      color: #333333;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.04rem;
      }
    }
    .list {
      background: #ffffff;
      padding-top: 0.16rem;
      &.list_gray {
        background: #EEEEEE;
        padding-top: 0.1rem;
        ul {
          padding: 0 0.11rem;
          b {
            font-weight: 400;
            color: #666666 !important;
            white-space: nowrap;
          }
        }
      }
      .ranking {
        align-items: flex-end;
        margin: 0.1rem 0.05rem 0;
        .No {
          position: relative;
          img {
            width: 100%;
            flex-shrink: 0;
          }
          .content {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            padding: 0.27rem 0.15rem 0.08rem;
            text-align: center;
            img {
              width: 0.34rem;
              height: 0.34rem;
              border-radius: 50%;
              margin: 0 auto;
            }
            p {
              color: #333333;
              margin: 0.08rem 0 0.04rem;
            }
            b {
              display: block;
              line-height: 0.21rem;
            }
            span {
              color: #666666;
              display: block;
              line-height: 0.14rem;
            }
          }
          &.No1 {
            .content {
              img {
                width: 0.46rem;
                height: 0.46rem;
              }
              b {
                color: #FFB103;
              }
            }
          }
          &.No2 {
            .content {
              b {
                color: #C1C4D8;
              }
            }
          }
          &.No3 {
            .content {
              b {
                color: #E19E4F;
              }
            }
          }
        }
      }
      ul.listitem {
        margin: 0 0.11rem 0.1rem;
        background: #ffffff;
        border-radius: 0.08rem;
        li {
          padding: 0.1rem 0.09rem;
          padding-left: 0;
          position: relative;
          span {
            color: #B3B3B3;
            margin-right: 0.2rem;
            padding-left: 0.09rem;
            &.color-FC0324 {
              color: #FC0324;
              margin-right: 0;
            }
          }
          img {
            width: 0.34rem;
            height: 0.34rem;
            border-radius: 50%;
            margin-right: 0.1rem;
          }
          p {
            color: #333333;
          }
          b {
            color: #333333;
          }
          &:after {
            content: '';
            width: 100%;
            height: 0.01rem;
            background: #F5F5F5;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
          }
        }
      }
    }
    .integral {
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      .intCenter {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        img {
          width: 1.12rem;
          height: 1.12rem;
          margin: 0 auto;
        }
        p {
          font-size:0.13rem;
          font-weight:400;
          color:rgba(41,41,41,1);
          line-height:0.18rem;
          margin-top: 0.23rem;
          margin-bottom: 0.96rem;
          text-align: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/newproducttrial/powerlist.vue